import React, { createContext } from 'react'
const BrandContext = createContext({ brands: null })
export default BrandContext
